import * as Constants from "DistributedTask/Scripts/Constants";
import * as Resources from "DistributedTask/Scripts/Resources/TFS.Resources.DistributedTask";

import { SourceBase } from "DistributedTaskControls/Common/Sources/SourceBase";
import { SourceManager } from "DistributedTaskControls/Common/Sources/SourceManager";
import { DefinitionResourceReferenceBuildHttpClient } from "DistributedTasksCommon/DefinitionResourceReferenceBuildHttpClient";

import * as Build from "TFS/Build/Contracts";

import * as VSSContext from "VSS/Context";
import { VssConnection } from "VSS/Service";
import * as Utils_String from "VSS/Utils/String";

/**
 * @brief Source implementation for Tasks related communications with the server
 */
export class DefinitionResourcePolicySource extends SourceBase {

    public static getKey(): string {
        return "DefinitionResourcePolicySource";
    }

    public getDefinitionResourceRefBuildClient = (): DefinitionResourceReferenceBuildHttpClient => {
        if (!this._defResourceRefBuildClient) {
            this._defResourceRefBuildClient = this._getVssConnection().getHttpClient<DefinitionResourceReferenceBuildHttpClient>(DefinitionResourceReferenceBuildHttpClient);
        }
        return this._defResourceRefBuildClient;
    }

    public getVariableGroupResourceAuthorization = (variablegroupid: string): Promise<Build.DefinitionResourceReference[]> => {
        return this._getResourceAuthorization(variablegroupid, Constants.LibraryConstants.VariableGroup, Resources.ErrorLoadingVGPolicy);
    }

    private _getResourceAuthorization = async (id: string, type: string, errorMessageFormat: string): Promise<Build.DefinitionResourceReference[]> => {
        const projectId = VSSContext.getDefaultWebContext().project.id;

        try {
            return await this.getDefinitionResourceRefBuildClient().getProjectResources(projectId, type, id);
        }
        catch (error) {
            throw new Error(Utils_String.localeFormat(errorMessageFormat, "\r\n", error.message || error));
        }
    }

    public authorizeVariableGroup = (variablegroupid: string, variablegroupname: string, shouldAuthorize: boolean): Promise<Build.DefinitionResourceReference[]> => {
        return this._authorizeResource(variablegroupid, variablegroupname, shouldAuthorize, Constants.LibraryConstants.VariableGroup, Resources.ErrorSavingVGPolicy);
    }

    private _authorizeResource = async (id: string, name: string, shouldAuthorize: boolean, type: string, errorMessageFormat: string): Promise<Build.DefinitionResourceReference[]> => {
        const resourceReference: Build.DefinitionResourceReference = {
            authorized: shouldAuthorize,
            id,
            name,
            type
        };
        const projectId = VSSContext.getDefaultWebContext().project.id;

        try {
            return await this.getDefinitionResourceRefBuildClient().authorizeProjectResources([resourceReference], projectId);
        }
        catch (error) {
            throw new Error(Utils_String.localeFormat(errorMessageFormat, "\r\n", error.message || error));
        }
    }

    /**
     * @returns vssConnection object
    */
    private _getVssConnection = (): VssConnection => {
        if (!this._vssConnection) {
            this._vssConnection = new VssConnection(VSSContext.getDefaultWebContext());
        }
        return this._vssConnection;
    }

    public static instance = (): DefinitionResourcePolicySource => {
        return SourceManager.getSource(DefinitionResourcePolicySource);
    }

    private _vssConnection: VssConnection;
    private _defResourceRefBuildClient: DefinitionResourceReferenceBuildHttpClient;
}